import React, { useEffect } from "react";
import moment from "moment";
import { debounce } from "lodash";
import copy from "copy-to-clipboard";
import "./index.less";
import "../Profile/index.less";
import {
	Button,
	Row,
	Col,
	Space,
	Tag,
	Form,
	Input,
	Select,
	Pagination,
	message,
	Tooltip,
} from "antd";
import sortData from "../../../utils/sorter";
import { effect, useStore } from "../../../utils/dva16";
import {
	EGet,
	NCompany,
	NGame,
	NGenre,
	NPlatform,
	NInsightsFeed,
} from "../../../models/contants";
import { CopyOutlined } from "@ant-design/icons";
const { Option } = Select;

export default (props) => {
	const { history } = props;
	const [form] = Form.useForm();
	const { InsightsFeedList } = useStore(NInsightsFeed);
	const { companyData } = useStore(NCompany);
	const { GameList } = useStore(NGame);
	const { GenreList } = useStore(NGenre);
	const { PlatformData } = useStore(NPlatform);
	useEffect(() => {
		effect(NInsightsFeed, EGet, { region: "China", page: 1, perPage: 10 });
		effect(NCompany, EGet, { page: 1, perPage: 10 });
		effect(NGame, EGet, { page: 1, perPage: 10 });
		effect(NGenre, EGet, { page: 1, perPage: 30 });
		effect(NPlatform, EGet, { page: 1, perPage: 25 });
		return () => {};
	}, []);
	const onPageChange = (page, pageSize) => {
		effect(NInsightsFeed, EGet, { region: "China", page, perPage: pageSize });
	};
	const onSearchCompany = (value) => {
		effect(NCompany, EGet, { ...{ company: value }, page: 1, perPage: 10 });
	};
	const onSearchGame = (value) => {
		effect(NGame, EGet, { ...{ keyword: value }, page: 1, perPage: 10 });
	};
	const onSearchGenre = (value) => {
		effect(NGenre, EGet, { ...{ genre: value }, page: 1, perPage: 10 });
	};
	const onSearchPlatform = (value) => {
		effect(NPlatform, EGet, { ...{ platform: value }, page: 1, perPage: 10 });
	};

	const onFinish = (values) => {
		if (values?.date) {
			values.startDate = moment(values?.date[0])?.format("YYYY-MM-DD");
			values.endDate = moment(values?.date[1])?.format("YYYY-MM-DD");
		}
		delete values?.date;
		effect(NInsightsFeed, EGet, {
			...values,
			region: "China",
			page: 1,
			perPage: 10,
		});
	};
	const onReset = () => {
		form.resetFields();
		effect(NInsightsFeed, EGet, { region: "China", page: 1, perPage: 10 });
	};
	return (
		<div>
			<div
				className="BlogBox mt50"
				style={{ backgroundColor: "#F7F9FB", padding: "40px 40px 20px 0px" }}
			>
				<Form
					name="advanced_search"
					className="ant-advanced-search-form"
					labelCol={{ span: 8 }}
					form={form}
					onFinish={onFinish}
				>
					<Row>
						<Col span={8}>
							<Form.Item
								name="keyWord"
								label="Keyword(s)"
								rules={[
									{
										required: false,
										message: "Input something!",
									},
								]}
							>
								<Input placeholder="Input something" />
							</Form.Item>
						</Col>

						<Col span={8}>
							<Form.Item name="company" label="Company">
								<Select
									getPopupContainer={(triggerNode) => triggerNode.parentNode}
									showSearch
									filterOption={false}
									placeholder="Select"
									showArrow
									onSearch={debounce((value) => {
										onSearchCompany(value);
									}, 300)}
								>
									{companyData?.data?.map((item, index) => {
										return (
											<Option key={index} value={item?.id}>
												{item?.nameEn}
											</Option>
										);
									})}
								</Select>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item name="game" label="Game">
								<Select
									getPopupContainer={(triggerNode) => triggerNode.parentNode}
									showSearch
									filterOption={false}
									placeholder="Select"
									showArrow
									onSearch={debounce((value) => {
										onSearchGame(value);
									}, 300)}
								>
									{GameList?.data?.map((item, index) => {
										return (
											<Option key={index} value={item?.id}>
												{item?.nameEn}
											</Option>
										);
									})}
								</Select>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item name="genres" label="Genre">
								<Select
									getPopupContainer={(triggerNode) => triggerNode.parentNode}
									showSearch
									filterOption={false}
									placeholder="Select"
									showArrow
									onSearch={debounce((value) => {
										onSearchGenre(value);
									}, 300)}
								>
									{sortData(GenreList?.data, "genre")?.map((item, index) => {
										return (
											<Option key={index} value={item?.genre}>
												{item?.genre}
											</Option>
										);
									})}
								</Select>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								name="platform"
								label="Platform"
								//
								rules={[
									{
										required: false,
										message: "Input something!",
									},
								]}
							>
								<Select
									getPopupContainer={(triggerNode) => triggerNode.parentNode}
									showSearch
									filterOption={false}
									placeholder="Select"
									showArrow
									onSearch={debounce((value) => {
										onSearchPlatform(value);
									}, 300)}
								>
									{sortData(PlatformData?.data, "platform")?.map(
										(item, index) => {
											return (
												<Option key={index} value={item?.platform}>
													{item?.platform}
												</Option>
											);
										}
									)}
								</Select>
							</Form.Item>
						</Col>
						<Col span={24} style={{ textAlign: "right" }}>
							<Space>
								<Button
									type="primary"
									htmlType="submit"
									className="primarySearch"
								>
									Search
								</Button>
								<Button
									type="default"
									htmlType="button"
									onClick={onReset}
									className="secReset"
								>
									Reset
								</Button>
							</Space>
						</Col>
					</Row>
				</Form>
			</div>

			<div className="BlogBox">
				<Row className="RowBox mt30">
					<Col span={24}>
						<ul className="ProlistBox">
							{InsightsFeedList?.data?.map((vo, i) => (
								<li key={i} style={{ padding: "20px 0" }}>
									<img
										src={
											vo?.logo ||
											"data:image/png;base64,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"
										}
										className="insght_pic"
									/>
									<div className="insight_list_cont">
										<h3>
											<div>{vo?.title}</div>

											<div className="insight_list_date_style">
												<Tooltip placement="top" title={"COPY"}>
													<CopyOutlined
														onClick={(e) => {
															copy(
																vo?.title + "\n" + vo?.info + "\n" + vo?.link
															);
															message.success({
																content: "Copied Success",
																duration: 5,
																className: sc,
															});
														}}
													/>
												</Tooltip>
												{moment(vo?.date)?.format("YYYY-MM-DD")}
											</div>
										</h3>
										<div className="Tag_List_Box">
											{vo?.withCompanys?.map((vi, ii) => (
												<Tag
													key={ii}
													color="#9E219E"
													onClick={() => {
														history.push(`/organizations/details/${vi?.id}`);
													}}
													style={{ cursor: "pointer", borderRadius: "20px" }}
												>
													{vi?.nameEn}
												</Tag>
											))}
											{vo?.withGames?.map((vi, iii) => (
												<Tag
													key={iii}
													color="#19AE54"
													onClick={() => {
														history.push(`/games/details/${vi?.id}`);
													}}
													style={{
														cursor: "pointer",
														borderRadius: "20px",
													}}
												>
													{vi?.nameEn}
												</Tag>
											))}
										</div>

										<div className="insght_lst_info">{vo?.info}</div>
										<a href={vo?.link} target="_blank">
											{vo?.link}
										</a>
									</div>
								</li>
							))}
						</ul>
					</Col>
					<Col span={24} style={{ textAlign: "right" }}>
						{InsightsFeedList && (
							<Pagination
								current={InsightsFeedList?.page}
								total={InsightsFeedList?.total}
								pageSize={InsightsFeedList?.perPage}
								onChange={onPageChange}
								showSizeChanger
								showQuickJumper
							/>
						)}
					</Col>
				</Row>
			</div>
		</div>
	);
};
